import React, { useEffect, useRef } from 'react';
import { PopupProps } from '../../models';
import styles from './popup.module.scss';
import IconsColor from '../../util/iconsColor';
import Button from 'component/button/button';

const Popup: React.FC<PopupProps> = ({
  isOpen,
  onClose,
  title,
  children,
  size = 'medium',
  showCloseButton = true,
  primaryButton,
  secondaryButton,
  closeOnOverlayClick = true,
  heightFiexd = false,
  titleClassName,
}) => {
  const popupRef = useRef<HTMLDivElement>(null);

  // Handle escape key press
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden'; // Prevent background scroll
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  // Handle overlay click
  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (closeOnOverlayClick && e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.popupOverlay} onClick={handleOverlayClick}>
      <div className={styles.popupContainer + ' ' + styles[size]} ref={popupRef}>
        {/* Header */}
        <div className={styles.popupHeader}>
          <h2 className={`${styles.popupTitle}${titleClassName ? ` ${titleClassName}` : ""}`}>{title}</h2>
          {showCloseButton && (
            <button
              className={styles.popupCloseButton}
              onClick={onClose}
              aria-label="Close popup"
              type="button"
            >
              <IconsColor iconName="closeIcon" width="20px" height="20px" fillColor="none" strokeColor="currentColor" />
            </button>
          )}
        </div>

        {/* Content */}
        <div className={heightFiexd ? styles.popupContentFixedHeight : styles.popupContent}>
          {children}
        </div>

        {/* Footer with buttons */}
        {(primaryButton || secondaryButton) && (
          <div className={styles.popupFooter}>
            {secondaryButton && (
              <Button type="outlined" label={secondaryButton.label} onClick={secondaryButton.onClick} disabled={secondaryButton.disabled} />
            )}
            {primaryButton && (
              <Button type="contained" label={primaryButton.label} onClick={primaryButton.onClick} disabled={primaryButton.disabled} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Popup;

